module.exports = __webpack_public_path__ + "img/photo-of-night-sky-1025469.4c10244c.jpg";